<template>
    <div class="pm ">
        <el-row class="video-tree position">

            <el-col :span="treespan"  style="max-width:320px ;padding-top: 10px;height: 100%;background-color: rgb(201,201,201)" >
                <div class="grid-content bg-purple taskList" >
                    <task-list  ref="taskList" :tasklist="tasklist" @getValue="getValue"></task-list>
                </div>
            </el-col>
            <el-col :span="rightspan" class="position" style="height: 100%;padding-left: 20px">
                <el-button icon="el-icon-arrow-left" class="icon right" @click="closeTree" v-show="isright"></el-button>
                <el-button icon="el-icon-arrow-right" class="icon left" @click="openTree" v-show="!isright"></el-button>
                <div class="grid-content bg-purple-light tabsList">
                    <tabs-list ref="tabsList" :tabslist="tabslist" @refreshTask="refreshTask"></tabs-list>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    // import * as API from "./api"
    import TaskList from "./TaskList";
    import TabsList from "./TabsList";
    export default {
        name: "attendancePlan",
        components: {TabsList,
                     TaskList
                    },
        data() {
            return {
                tasklist:{},
                tabslist:{},
                treespan:5,
                rightspan:19,
                isright:true,
                socket:null

            }
        },
        mounted() {

        },

        methods: {

            getValue(data){
                this.tabslist=data;
                // console.log("tabslistdata",this.tabslist,data)
            },
            refreshTask(data){
                this.tasklist=data;
                this.$refs.taskList.append(data);

                /*this.tasklist.find(item=>{
                    if (item.i_id==data.i_id){
                        item=data;
                    }
                });
                console.log(this.tasklist)*/
                // console.log(data,this.tasklist,"TaskList1111111111111");
                // console.log(this.$refs.taskList,333)
               // if(this.tabslist.i_id==this.tasklist.i_id){
               //     this.$refs.taskList.append(this.tasklist);
               // }

                // this.tasklist.find=function (item) {
                //     if(item.i_id==)
                // }
                // let arr=data.map(item=>({
                //     i_weektype:item.i_weektype,
                //     vc_createuser:item.vc_createuser,
                //     vc_djmark:item.vc_djmark,
                //     vc_tcname:item.vc_tcname,
                //     dt_createtime:item.dt_createtime,
                //     i_start:item.i_start,
                //     i_end:item.i_end
                // }  ))
                //this.$refs.taskList.handleNodeClick(data);
                /*if (data.i_itype==0){
                    this.$refs.taskList.getScorderList(data.expanded);
                }else  if (data.i_itype==1){
                    this.$refs.taskList.getReplaceScorderList(data.expanded);
                }*/
                //console.log(data,"fu")
            },
            closeTree(){
                this.treespan=0;
                this.rightspan=24;
                this.isright=false;
            },
            openTree(){
                this.treespan=5;
                this.rightspan=19;
                this.isright=true;
            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/{
        .el-tabs--top{
            background-color: rgb(241,241,241);
        }
    }
    .pm{
        height: calc(100vh - 145px);
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 670px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 770px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 700px;
        }
    }*/

    //实现滚动功能
    /*.video-tree {
        overflow-y: auto;

    }*/
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }

</style>